import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import InstreamAdForm from './InstreamAdForm';
import API from "../../../services/axiosInstance";
import { FormLoader, useFormLoader } from "../../common_modules/loader";

const UpdateInstreamAd = () => {
    const [publisherName, setPublisherName] = useState("");
    // const id = useLocation().state;
    const { adId } = useParams();

    const [defaultValues, setDefaultValues] = useState(null);
    const url = useParams();
    const accId = url?.id;
    const accGuid = url?.guid;
    // custom hook loader
    const { isLoading, startLoading, stopLoading } = useFormLoader(); 
    
    const updateApi = async () => {
        try {
            startLoading();
            const updateApiRes = await API.get(`/publisher/instream/ad/setup/${adId}/${accId}`);
            const data = updateApiRes?.data?.data;
            console.log(data);
            setPublisherName(updateApiRes?.data?.name);
            setDefaultValues({
                id: data.id,
                accountId: Number(data?.accId),
                accountGuid: data?.accGuid,
                title: data.title,
                generation_type: data.generationType,
                status: Number(data?.status),
                ad_Format: data.adFormat,
                adSizes: data.adSize ? { value: data.adSize, label: data.adSize } : null,
                vast_tag_url: data.vastTagUrl,
                remarks: data.remarks,
                is_primary: Number(data.isPrimary),
            })
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            stopLoading();
        }
    }

    useEffect(() => {
        updateApi();
    }, []);


    // if (!defaultValues) return <p>Loading...</p>

    return (
            <InstreamAdForm mode="edit" defaultValues={defaultValues} publisherName={publisherName} />
    )
}

export default UpdateInstreamAd;